import { CSSTransition } from 'react-transition-group';
import LazyLoad from 'react-lazyload';
import { IconProductLensMolecule } from '../icon-product-lens';
import { IconProductDropsMolecule } from '../icon-product-drops';
import { IconProductBlgMolecule } from '../icon-product-blg';
import { ToggleMolecule } from '../toggle';
import React from 'react';
import { HomeOurProductItemProps } from './home-our-product-item.props';
import { useHomeOurProducts } from '../../../styles/organisms/home-our-products.styles';
import { useModal } from '../modal/modal.effect';
import { LensLabel } from '../../../data';
import { ModalMolecule } from '../modal';
import { LensReturnPolicyMolecule } from '../lens-return-policy';

export const HomeOurProductItemMolecule = (props: HomeOurProductItemProps) => {
  const classes = useHomeOurProducts();
  const [modalOpened, openModal, closeModal] = useModal();
  return (
    <>
      <div className="border-t border-white mt-3">
        <div
          className="text-center block w-full h-16  my-2 lg:my-3 cursor-pointer flex justify-center items-center relative"
          onClick={props.toggleFunc}
        >
          <span className="font-light text-mobileHeader text-white uppercase">
            {props.ourProductsDetails.title}
          </span>
          <span className="inline-block text-white  text-2xl lg:text-3xl absolute right-0">
            {props.funcOpened ? (
              <img
                src="images/icons/toggle_minus_icon.svg"
                className="w-3 lg:w-5"
              />
            ) : (
              <img
                src="images/icons/toggle_plus_icon.svg"
                className="w-3 lg:w-5"
              />
            )}
          </span>
        </div>

        <CSSTransition
          mountOnEnter
          unmountOnExit
          timeout={250}
          in={props.funcOpened}
          classNames={props.ourProductsDetails.transition}
        >
          <div
            className={`flex flex-col lg:flex-row w-full pt-10 focus: outline-none ${classes.ourProductSlides}`}
          >
            <div className="w-full lg:w-1/2 pr-0 lg:pr-10">
              <div className="focus:outline-none">
                <LazyLoad offset={380} height={380}>
                  <img
                    className=" w-full lg:w-93/100"
                    src={`/images/home/products/${props.ourProductsDetails.image}`}
                  />
                </LazyLoad>
              </div>
            </div>
            <div className="w-full lg:w-1/2 text-white focus:outline-none">
              <div className="focus:outline-none">
                <p className="text-white font-light mt-6 text-base">
                  {props.ourProductsDetails.desc}
                </p>

                <div className={props.ourProductsDetails.imgLens}>
                  <LazyLoad offset={100}>
                    <IconProductLensMolecule />
                  </LazyLoad>
                </div>
                <div className={props.ourProductsDetails.imgDrops}>
                  <LazyLoad offset={100}>
                    <IconProductDropsMolecule />
                  </LazyLoad>
                </div>
                <div className={props.ourProductsDetails.imgBlg}>
                  <LazyLoad offset={100}>
                    <IconProductBlgMolecule />
                  </LazyLoad>
                </div>

                <div className={`hidden lg:block`}>
                  {props.ourProductsDetails.content}
                  <div
                    className={`border-l-2 border-white pl-5  my-10 border-opacity-30 ${props.ourProductsDetails.displayPopUp}`}
                  >
                    <p className="text-white font-semibold text-base">
                      {LensLabel.RETURN_POLICY_HEADER}
                    </p>

                    <p className="text-white font-light text-base lg:w-3/4 mt-3 ">
                      {LensLabel.RETURN_POLICY_DESC}
                      <a
                        className=" font-normal text-white hover:text-white hover:underline ml-2 inline-block"
                        onClick={() => openModal()}
                      >
                        {' '}
                        {LensLabel.RETURN_CTA}{' '}
                        <img
                          src="/images/icons/learn-more-white.svg"
                          className="inline-block ml-1.5 -mt-1"
                        />
                      </a>
                    </p>
                  </div>
                </div>
                <div className="block lg:hidden">
                  {props.ourProductsDetails.content_mobile}
                  <div
                    className={`border-l-2 border-white pl-5  my-10 border-opacity-30 ${props.ourProductsDetails.displayPopUp}`}
                  >
                    <p className="text-white font-semibold text-h_5">
                      {LensLabel.RETURN_POLICY_HEADER}
                    </p>

                    <p className="text-white font-light text-h_5 lg:w-3/4 mt-3 ">
                      {LensLabel.RETURN_POLICY_DESC}
                      <a
                        className=" font-normal text-h_5 text-white hover:text-white hover:underline block mt-3"
                        onClick={() => openModal()}
                      >
                        {' '}
                        {LensLabel.RETURN_CTA}{' '}
                        <img
                          src="/images/icons/learn-more-white.svg"
                          className="inline-block ml-1.5 -mt-1"
                        />
                      </a>
                    </p>
                  </div>

                  <div className={props.ourProductsDetails.displayPopUp}></div>
                </div>

                <ToggleMolecule
                  title={'Specifications and Ingredients'}
                  display={props.ourProductsDetails.toggle}
                />
              </div>
            </div>
          </div>
        </CSSTransition>
        <ModalMolecule
          className="top-64 rounded-lg"
          closeIconImgSrc="/images/icons/close-popup.svg"
          opened={modalOpened}
          closeModal={() => closeModal()}
        >
          <LensReturnPolicyMolecule />
        </ModalMolecule>
      </div>
    </>
  );
};
